import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { RichTextEditorComponent } from '../forms/fields/rich-text-editor/rich-text-editor.component';

@Component({
  selector: 'app-rich-text-preview',
  standalone: true,
  imports: [TranslateModule, CommonModule, RichTextEditorComponent],
  templateUrl: './rich-text-preview.component.html',
  styleUrl: './rich-text-preview.component.scss'
})
export class RichTextPreviewComponent {
  constructor(private modalService: NgbActiveModal) { }
  @Input() title!: string;
  @Input() content!: string;

  close() {
    this.modalService.dismiss();
  }

}
